import * as React from 'react';
import { defaultSDKSettingsContext, SDKSettingsContext } from '@contexts/sdkSettings/SDKSettingsContext';
import { useServiceResolver } from '@services/useServiceResolver';

export function withSDKSettingsContext<TProps>(Component: React.FC<TProps>): React.FC<TProps> {
    const ComponentWithSDKSettingsContext: React.FC<TProps> = props => {
        const [sdkSettingsContext, setSDKSettingsContext] = React.useState<SDKSettingsContext | undefined>(undefined);
        const { sdkEffect } = useServiceResolver();

        React.useEffect(() => {
            (async () => {
                try {
                    const sdkSettingsFromRpc = await sdkEffect.onSpaWillLoad();
                    setSDKSettingsContext({
                        ...defaultSDKSettingsContext,
                        ...sdkSettingsFromRpc,
                    });
                } catch {
                    setSDKSettingsContext(defaultSDKSettingsContext);
                }
            })();
        }, []);

        return !!sdkSettingsContext ? (
            <SDKSettingsContext.Provider value={sdkSettingsContext}>
                <Component {...props} />
            </SDKSettingsContext.Provider>
        ) : (
            <></>
        );
    };

    ComponentWithSDKSettingsContext.displayName = `${Component.displayName || 'Component'}WithSDKSettingsContext`;

    return ComponentWithSDKSettingsContext;
}
